import script from "./AdminPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminPage.vue?vue&type=style&index=0&id=96c4448a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96c4448a"]])

export default __exports__